<template>
    <el-dialog
        :visible.sync="show"
        width="1130px" @closed="$emit('input', show)">
        <div class="ticketBox" v-if="bmInfo.permitNum" ref="print">
            <table>
                <tr><th colspan="5">CERM职业资格证书考试准考证</th></tr>
                <tr>
                    <td width="90">姓名</td>
                    <td class="ll"><b>{{ bmInfo.name }}</b></td>
                    <td width="80"><span>性别</span></td>
                    <td width="80"><span>{{ bmInfo.sex == 1 ? '男' : '女' }}</span></td>
                    <td rowspan="4" width="80"><img class="head" :src="bmInfo.headImg" alt=""></td>
                </tr>
                <tr>
                    <td>身份证号</td>
                    <td colspan="3" class="ll">{{ bmInfo.certificateNumber }}</td>
                </tr>
                <tr>
                    <td>准考证号</td>
                    <td colspan="3" class="ll">{{ bmInfo.permitNum }}</td>
                </tr>
                <tr>
                    <td>报考等级</td>
                    <td colspan="3" class="ll">{{ bmInfo.level }}</td>
                </tr>
                <tr>
                    <td class="f12">工作单位/<br>就读院校</td>
                    <td colspan="4" class="ll">{{ bmInfo.gzorby }}</td>
                </tr>
                <tr>
                    <td>考试时间</td>
                    <td colspan="4" class="ll">{{ bmInfo.examTime }}</td>
                </tr>
                <tr>
                    <td>考试地点</td>
                    <td colspan="4" class="ll dd">{{ bmInfo.addr }}</td>
                </tr>
                <tr>
                    <td>考场号</td>
                    <td colspan="4" class="ll">{{ bmInfo.examRoomNo }}</td>
                </tr>
                <tr>
                    <td colspan="5" class="ll">准考证颁发机构：CERM中国考试认证管理中心-谐同神州（北京）风险管理顾问中心<br>  准考证监制机构：亚洲风险与危机管理协会（AARCM）</td>
                </tr>
                <tr>
                    <td colspan="5">
                        <h2>注意事项：</h2>
                        <ul>
                            <li>请仔细核对准考证信息，确认无误，若准考证信息与事实不符，请致电CERM考试认证管理中心查询，电话：010-53391240；</li>
                            <li>请考生自备黑色签字笔；</li>
                            <li>在考试前30分钟，凭准考证、身份证、学生证（学生携带）进入考场，对号入座；考试过程中须将证件放在课桌上方接受检查；</li>
                            <li>开始考试30分钟后，不得入场；考试开始30分钟内，不得退场；</li>
                            <li>试卷一律用黑色签字笔在指定位置作答，答题卡需用2B铅笔填涂；</li>
                            <li>进入考场，只能带签字笔、手表等必备工具，严禁携带书包、手机、手提电脑、草稿纸、书籍资料等物品；</li>
                            <li>考试过程中，需保持考场肃静，如有问题，举手示意监考人员；</li>
                            <li>严禁替考或转借《准考证》；如发现替考，被替考人3年内禁止参加CERM各级别考试；</li>
                            <li>考生须服从监考人员的安排，自觉接受监督、检查，严格遵守考场纪律；</li>
                            <li>考场内备有摄像/照相设备，如有违纪行为，监考人员将当场拍照，核实后考试成绩被取消。</li>
                        </ul>
                    </td>
                </tr>
            </table>
            <div class="tipBox">
                <h2>企业风险管理师（CERM）考生考试违纪处理规则</h2>
                <dl>
                    <dt>（1）关于一级违规的定义。考生在考试中有下列行为之一者，属于违反考场纪律，给予警告处分。针对被警告二次的考生，将取消是次考试成绩：</dt>
                    <dd>不按指定位置就坐，且不听监考人员调动者；</dd>
                    <dd>监考人员要求出示准考证、身份证（或者护照）而拒绝出示者；</dd>
                    <dd>考试过程中未经监考人员同意而擅自进出考场者；</dd>
                    <dd>考试过程中吸烟、喧哗、交头接耳或其他影响考场秩序者；</dd>
                    <dd>交卷后未及时离开考场，且不听监考人员劝告者。</dd>
                    <dt>（2）关于二级违规的定义。考生在考试中有下列行为之一者，属于考试作弊，将取消是次考试成绩：</dt>
                    <dd>将手机等通讯工具带入考场，不听从监考人员要求上交手机者，或者不按照要求关闭手机且不按照要求将手机放到指定的特殊存放地点者，或者考试期间触碰手机者。特别提示的是：针对对手机具有保密特殊要求的考生，允许其将关闭的手机置入身份证存放点，并建议采用胶条封存；</dd>
                    <dd>采用手机拍照答题卡，并传送答题卡信息者；</dd>
                    <dd>偷看或抄袭他人试卷者；</dd>
                    <dd>传递纸条、打手势、交换试卷，以及有意将自己的试卷让他人抄袭者；</dd>
                    <dd>考试中翻看或夹带与考试内容有关的东西（包括考生座位周围和抽屉里的东西）；</dd>
                    <dd>试卷、答题卡、草稿纸人为撕毁者；</dd>
                    <dd>将试卷、答题卡、草稿纸带出考场者；</dd>
                    <dd>交卷中，看别人答案并涂改试卷者；</dd>
                    <dd>涂改他人试卷姓名并将其占为己有者；</dd>
                    <dd>无理取闹、破坏公物及考场设施、扰乱考场秩序。</dd>
                    <dt>（3）关于三级违规的定义。考生在考试中有下列行为之一者，属于严重违反考场纪律，在未来3年内禁止参加任何级别的CERM考试：</dt>
                    <dd>身份造假者；</dd>
                    <dd>请他人替考者；</dd>
                    <dd>有组织与预谋的团伙作弊者。例如，收到他人手机拍照答题卡信息，一经监考人员发现（以手机存留信息为证），可能被视为“团伙作弊”。特别提示的是：团伙的人数数量等于和超过3人，且共同作弊；</dd>
                    <dd>已构成考试作弊，拒不服从监考人员处理，故意纠缠、谩骂以及严重扰乱考场纪律者。</dd>
                </dl>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dy">打印准考证</el-button>
        </span>
    </el-dialog>
</template>

<script>

import Print from '@/utils/print'
import Vue from 'vue'
Vue.use(Print)
export default {
    data(){
        return {
            show: false
        }
    },
    props: ['value', 'bmInfo'],
    mounted(){
        
    },
    methods: {
        dy(){
            this.$print(this.$refs.print)
        }
    },
    watch:{
        value:function(val){
            this.show = val
        }
    }
}
</script>

<style scoped>
    >>> .el-dialog__footer{text-align: center;}
    .invoice >>> .el-radio-button__inner{width: 120px;height: 35px;border:1px solid #999999;font-size: 14px;color: #000;line-height: 33px;text-align: center;padding: 0;margin-right: 10px;border-radius: 0 !important;box-shadow: none;}
    .invoice >>> .is-active .el-radio-button__inner{background: #bf371e;border-color: #bf371e;color: #fff;}
    .invoice >>> .el-tabs__header{margin-bottom: 10px;}
    .invoice >>> .el-tabs__active-bar{display: none;}
    .invoice >>> .el-tabs__nav-wrap::after{display: none;}

    .buttons{text-align: center;margin-top: 40px;}

    .ticketBox{overflow: hidden;}
    .ticketBox table{width: 540px;height: 772px;border:1px solid #999;float: left;}
    .tipBox{width: 540px;height: 772px;border:1px solid #999;float: right;box-sizing:border-box;}
    .ticketBox table th{border:1px solid #999;text-align: center;}
    .ticketBox table td{border:1px solid #999;text-align: center;}
    .ticketBox ul{padding-left: 30px;text-align: left;padding-right: 10px;text-align: justify;padding-bottom: 10px;}
    .ticketBox h2{text-align: left;font-weight: 600;padding-left: 15px;line-height: 30px;padding-top: 10px;}
    .ticketBox ul li{list-style: decimal;}
    .ticketBox table td.ll{text-align: left;text-align: justify;padding-left: 15px;padding-right: 15px;}
    .ticketBox table td.f12{font-size: 12px;line-height: 15px;padding: 3px 0;}
    .ticketBox table td b{font-weight: normal;}
    img.head{width: 80px;height: 112px;display: block;margin: 4px;}
    /*按钮*/
    .dialog-footer >>> .el-button{
        width: 150px;height: 35px;line-height: 35px;padding: 0;margin: 0;border:0;border-radius: 5px;color: #fff;font-size: 14px;
        background: -webkit-linear-gradient(#bf371e, #942424);
        background: -o-linear-gradient(#bf371e, #942424);
        background: -moz-linear-gradient(#bf371e, #942424);
        background: linear-gradient(#bf371e, #942424);
    }

    .tipBox h2{text-align: center;font-size: 15px;line-height: 34px;margin-bottom: 4px;}
    .tipBox dl{padding:0 10px;text-align: justify;line-height: 22px;}
    .tipBox dd{padding-left: 24px;}
    @media print{
        .ticketBox h2{padding-left: 30px;padding-top: 30px;margin-bottom: 10px;}
        .ticketBox table th{line-height: 66px;}
        .ticketBox table td.ll{padding-left: 30px;padding-right: 30px;}
        .ticketBox table{width: 1074px;float: none;border-collapse:collapse;}
        img.head{width: 146px;height: 205px;display: block;margin: 8px;}
        .ticketBox table *{font-size: 30px;line-height: 50px;}
        .ticketBox table td.f12{font-size: 28px;line-height: 36px;padding: 8px 0;}
        .ticketBox ul{padding-left: 60px;padding-right: 30px;padding-bottom: 30px;}
        .ticketBox table td.dd{font-size: 26px;letter-spacing:-2;}
        .ticketBox table td span{display: block;width: 150px;}
        .ticketBox table td b{display: block;width: 240px;}
        .tipBox{width: 1074px;float: none;height: 1550px;}
        .tipBox h2{text-align: center;font-size: 32px;line-height: 50px;margin-bottom: 20px;}
        .tipBox dl{padding:0 30px;line-height: 44px;font-size: 28px;}
        .tipBox dd{padding-left: 50px;}
    }
</style>